export default __webpack_public_path__ + "static/media/Solar_Regular.8d2cb726.otf";